import { useState } from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemButton,
  Collapse,
  Typography,
  Box,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import menu from "../components/menu";
import { lighten } from "@mui/material";
import logo from "../assets/images/fulllogo.png";
import { KeyboardArrowRight } from "@mui/icons-material";
import { KeyboardArrowDown } from "@mui/icons-material";
import useLocalStorage from "../hooks/useLocalStorage";
import useMediaQuery from "@mui/material/useMediaQuery";

// const roles: string[] = [];

function SingleRender({
  item,
  isChild,
  closeDrawer,
}: {
  item: any;
  isChild?: boolean;
  closeDrawer: any;
}) {
  const { roles, name } = useLocalStorage();
  const matches = useMediaQuery("(min-width:1200px)");

  return (
    (roles?.includes(item.role) || name == "admin") && (
      <ListItem
        disablePadding
        sx={{
          a: { textDecoration: "none", color: "inherit" },
          "& .MuiListItemIcon-root": {
            py: 0.3,
            borderRadius: "3px",
          },
        }}
        key={item.id}
      >
        <NavLink
          onClick={() => !matches && closeDrawer(false)}
          to={item.route}
          className={({ isActive, isPending }) =>
            isActive ? "active-route" : ""
          }
        >
          <ListItemButton dense>
            <ListItemIcon
              sx={{
                pl: isChild ? 4 : 0,
              }}
            >
              {item.icon}

              <Typography
                sx={{
                  flex: 1,
                  alignContent: "flex-end",
                  color: (theme) => theme.palette.text.primary,
                  ml: 2,
                  py: 0.2,
                  pr: 2,
                  fontSize: isChild ? "0.9rem" : "1rem",
                }}
              >
                {item.title}
              </Typography>
            </ListItemIcon>
          </ListItemButton>
        </NavLink>
      </ListItem>
    )
  );
}

function NestedRender({
  item,
  isChild,
  closeDrawer,
}: {
  item: any;
  isChild?: boolean;
  closeDrawer: any;
}) {
  const [openItems, setOpenItems] = useState<any>({});
  const { roles, name } = useLocalStorage();

  const toggleItem = (name: any) => {
    setOpenItems((prev: any) => ({
      ...prev,
      [name]: !prev[name], // Toggle the current item's state
    }));
  };
  return (
    (roles?.includes(item.role) || name == "admin") && (
      <List disablePadding dense key={item.title}>
        <ListItemButton
          sx={{
            py: 1.5,
            border: "1px solid rgba(0,0,0,0.04)",
            borderRadius: "3px",
          }}
          onClick={() => toggleItem(item.title)}
        >
          <ListItemIcon sx={{ pl: isChild ? 1 : 0 }}>
            {item.icon}
            <Typography
              sx={{
                alignContent: "flex-end",
                py: 0.2,
                ml: 2,
                fontSize: isChild ? "0.9rem" : "1rem",
                color: (theme) => theme.palette.text.primary,
              }}
            >
              {item.title}
            </Typography>
          </ListItemIcon>
          {openItems[item.title] ? (
            <KeyboardArrowDown sx={{ ml: "auto" }} />
          ) : (
            <KeyboardArrowRight sx={{ ml: "auto" }} />
          )}
        </ListItemButton>
        <Collapse in={openItems[item.title]} timeout="auto" unmountOnExit>
          {item?.children?.map((child: any) =>
            child.children ? (
              <NestedRender
                key={child.title}
                item={child}
                isChild={true}
                closeDrawer={closeDrawer}
              />
            ) : (
              <SingleRender
                key={child.title}
                item={child}
                isChild={true}
                closeDrawer={closeDrawer}
              />
            )
          )}
        </Collapse>
      </List>
    )
  );
}

function SideBarMenu({
  headerHeight,
  closeDrawer,
}: {
  headerHeight?: number;
  closeDrawer: any;
}) {
  return (
    <Box
      sx={{
        boxShadow: "1px 2px 2px 1px rgba(0,0,0,0.2)",
        height: headerHeight ? "100vh" : `calc(100vh - 64px)`,
        backgroundColor: (theme) => lighten(theme.palette.primary.light, 0.8),
      }}
    >
      {/* <Box
        sx={{
          px: 1,
          mb: -2,
          height: "110px",
          width: "100%",
        }}
      >
        <img src={logo} alt="logo" style={{ width: "100%", height: "100%" }} />
      </Box> */}

      <Box
        sx={{
          "& .active-route": {
            backgroundColor: (theme) => theme.palette.action.selected,
            borderRadius: "0 50px 50px 0",
          },

          height: headerHeight ? "100vh" : `calc(100vh - 64px - 88px )`,
          overflowY: "auto",
        }}
      >
        {menu.map((item, index) =>
          item?.children ? (
            <NestedRender key={index} item={item} closeDrawer={closeDrawer} />
          ) : (
            <SingleRender key={index} item={item} closeDrawer={closeDrawer} />
          )
        )}
      </Box>
    </Box>
  );
}

export default SideBarMenu;
